var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoweredBySkrappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3559"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1528"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.149 7.083-.887-1.647h-3.813V20.41h5.706v-7.621c0-1.915.848-2.719 2.853-2.719h2.241V5.36h-1.5a5.928 5.928 0 0 0-4.6 1.723Z",
    "data-name": "Path 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.23 5.437h-6.4l-3.971 5.859-.964 1.3 5.128 7.812h6.748l-5.706-7.85Z",
    "data-name": "Path 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.619 5.991h.964v2.391h.964V5.991h.964V5.22h-2.892Z",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.772 8.328c-2.043-.463-3.663-.848-3.663-1.927 0-.925 1-1.311 2.082-1.311 1.234 0 2.236.578 2.236 1.812h5.939c0-3.971-2.969-6.4-8.1-6.4-5.087-.001-8.21 2.199-8.21 6.052 0 4.434 3.971 5.321 7.095 6.015 2.044.463 3.74.81 3.74 2.044 0 1.08-1.2 1.658-2.429 1.658-1.35 0-2.545-.694-2.545-2.082h-6.131c0 4.241 3.393 6.786 8.675 6.786 5.012 0 8.6-2.2 8.6-6.478-.001-4.472-4.127-5.396-7.289-6.169Z",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.999 0h-5.706v20.512h5.706V0Z",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.675 5.22h-.964l-.81 1.735-.813-1.735h-.964l-.54 3.162h.964l.27-1.812.925 1.812h.308l.925-1.812.27 1.812h.964Z",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.514 13.623-3.509-8.29h-6.207l6.863 13.8c-.771 1.889-1.427 2.391-3.624 2.391h-1.581v4.473h1.966c4.28 0 6.362-1.658 8.6-6.285l6.94-14.382h-6.131Z",
    "data-name": "Path 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.73 4.832a8.088 8.088 0 0 0-5.09 1.7l-1.272 1.157a17.615 17.615 0 0 0-3.663 5.784 4 4 0 0 1-3.663 2.853 3.441 3.441 0 1 1 0-6.863 3.588 3.588 0 0 1 3.547 2.352 17.773 17.773 0 0 1 3.2-4.588 9.072 9.072 0 0 0-6.362-2.352 8.089 8.089 0 0 0-5.09 1.7l-.733-1.2h-3.893v20.509h5.668v-5.976a8.184 8.184 0 0 0 4.049 1 10.517 10.517 0 0 0 1.581-.116 5.943 5.943 0 0 0 2.044-.925 11.059 11.059 0 0 0 3.856-4.665 13.992 13.992 0 0 1 3.393-4.781 3.836 3.836 0 0 1 2.66-1 3.441 3.441 0 1 1-3.7 3.432v-.193a20.248 20.248 0 0 0-1.619 2.815 11.535 11.535 0 0 1-4.588 5.244v5.09h5.668v-5.9a8.184 8.184 0 0 0 4.049 1c5.09 0 8.714-3.354 8.714-8.058-.042-4.665-3.667-8.019-8.756-8.019Z",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.252 6.583a8.392 8.392 0 0 0-5.09-1.609c-5.09 0-8.714 3.295-8.714 7.93s3.624 8.007 8.714 8.007a8.387 8.387 0 0 0 5.012-1.571l.5 1.073h4.434V5.434h-4.28Zm-4.28 9.73a3.421 3.421 0 1 1 3.7-3.41 3.452 3.452 0 0 1-3.696 3.41Z",
    "data-name": "Path 18"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "Powered by",
    fontFamily: "hk-grotesk, HKGrotesk-Regular, HK Grotesk",
    fontSize: 20,
    transform: "translate(0 19)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Powered by")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredBySkrappy);
export default __webpack_public_path__ + "static/media/PoweredBySkrappy.4038d9fbba03862e0148c837502906a9.svg";
export { ForwardRef as ReactComponent };